export default {
    headline: 'Hoppla',
    paragraph: 'Wir konnten die passende Seite nicht finden.',
    link: 'Zur Startseite',
};
